module.exports = __webpack_public_path__ + "static/img/3121.ed2fb6ee.png";